/** @jsxImportSource @emotion/react */
import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import ResponsiveImage from "../../../../../../components/ResponsiveImage";
import Strip from "../../../../../../components/Strip";
import ReactMarkdown from "react-markdown";
import AnimationOnScroll from "react-animate-on-scroll";

function PostEnrolmentStrip() {
  const { t } = useTranslation("dmuk");
  return (
    <Strip>
      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <Box mb={4} textAlign={{ xs: "center", sm: "left" }}>
            <Typography
              variant="body1"
              component="p"
              gutterBottom
              align="inherit"
              color="secondary.contrastText"
            >
              {t("postenrol.pre")}
            </Typography>
            <Typography
              variant="h4"
              component="h2"
              align="inherit"
              gutterBottom
              color="primary"
            >
              {t("faqs.sections.2.5.q")}
            </Typography>

            <Typography variant="body1" component="span">
              <ReactMarkdown>{t("faqs.sections.2.5.a")}</ReactMarkdown>
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <AnimationOnScroll animateIn="animate__fadeInRight">
            <ResponsiveImage
              src="/images/screenuk.png"
              alt={t("postenrol.imgAlt")}
              isRaised={false}
            />
          </AnimationOnScroll>
        </Grid>
      </Grid>
    </Strip>
  );
}

export default PostEnrolmentStrip;
